import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../features/meta/metaSlice";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { AppSidebar } from "./Sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";

const MainLayout: React.FC = () => {
  const darkMode = useSelector(selectDarkMode);
  const location = useLocation();

  // Check if current path is an auth route
  const isAuthRoute = location.pathname.startsWith("/auth");

  return (
    <div className={`${darkMode ? "dark" : ""} font-sans`}>
      <div className="min-h-screen bg-gray-100 text-gray-900">
        {isAuthRoute ? (
          // For auth routes, only render the content without navigation elements
          <main>
            <Outlet />
          </main>
        ) : (
          // For regular routes, render the full layout with navigation
          <SidebarProvider>
            <AppSidebar />
            <div className="flex-1">
              <Navbar />
              <main className="p-4">
                <Outlet />
              </main>
              <Footer />
            </div>
          </SidebarProvider>
        )}
      </div>
    </div>
  );
};

export default MainLayout;
